import { createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from '../../services/auth.service';
import { showHideLoader } from '../common/common.slice';
import jwt_decode from "jwt-decode";

// Async Thunk Actions

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.

// User login Action
const loginAction = createAsyncThunk(
  'authSlice/authAction', (payload: { email: string, password: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.authActionService(payload)
      .then((response) => {
        dispatch(showHideLoader(false));
        
        return response;
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false));
        return rejectWithValue(error?.response);
      })
  }
);

// project list action
const getpProjectListAction = createAsyncThunk(
  'authSlice/getpProjectListAction', (_, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.getProjectListService()
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// select project action
const selectProjectAction = createAsyncThunk(
  'authSlice/selectProjectAction', (payload: { projectId: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.selectProjectService(payload)
      .then((response) => {
        dispatch(showHideLoader(false));
        
        return response;
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// set favorite project action

const setFavoriteProjectAction = createAsyncThunk(
  'authSlice/setFavoriteProjectAction', (payload: { projectId: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.setFavoriteProjectService(payload)
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// Send OTP Action
const sendOtpAction = createAsyncThunk(
  'authSlice/sendOtpAction', (payload: { email: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.sendOtpService(payload)
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// Verify OTP Action
const verifyOtpAction = createAsyncThunk(
  'authSlice/verifyOtpAction', (payload: { code: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.verifyOtpService(payload)
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// Reset Password Action
const resetPasswordAction = createAsyncThunk(
  'authSlice/resetPasswordAction', (payload: { code: string, password: string, confirmPassword: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.resetPasswordService(payload)
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// Register User Action
const registerUserAction = createAsyncThunk(
  'authSlice/registerUserAction', (payload: { token: string | undefined,email: string, password: string, confirmPassword: string}, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return authService.registerUserService(payload)
      .then((response) => {
        dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// get user preferences
const getUserPreferencesAction = createAsyncThunk(
  'authSlice/getUserPreferencesAction', (id: string, { dispatch, rejectWithValue }) => {
    // dispatch(showHideLoader(true));
    return authService.getUserPreferenceService(id)
      .then((response) => {
        // dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        // dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// update user preferences
const updateUserPreferencesAction = createAsyncThunk(
  'authSlice/updateUserPreferencesAction', (payload: any, { dispatch, rejectWithValue }) => {
    // dispatch(showHideLoader(true));
    return authService.updateUserPreferenceService(payload)
      .then((response) => {
        // dispatch(showHideLoader(false))
        return response
      })
      .catch((error: { response: unknown; }) => {
        // dispatch(showHideLoader(false))
        return rejectWithValue(error?.response)
      })
  }
);

// Logout Action - handles permissions reset
const logoutAction = createAsyncThunk(
  'authSlice/logoutAction', (_, { dispatch }) => {
    // Clear localStorage
    localStorage.clear();
    
    
    // Return success (no API call needed for logout)
    return { success: true };
  }
);

// Initialize permissions from localStorage on app load
const initializePermissions = createAsyncThunk(
  'authSlice/initializePermissions', (_, { dispatch }) => {
    const token = localStorage.getItem('token');
    const isPrimaryUser = localStorage.getItem('isPrimaryUser') === 'true';
    const isReadOnly = localStorage.getItem('isReadOnly') === 'true';
    
    if (token) {
      try {
        // Just verify token is valid, we need both isPrimaryUser and isReadOnly flags
        jwt_decode(token);
                
        return { success: true, isPrimaryUser, isReadOnly };
      } catch (error) {
        // Invalid token, reset everything
        localStorage.clear();
        return { success: false, error: 'Invalid token' };
      }
    } else {
      return { success: false, error: 'No token found' };
    }
  }
);

export const authActions = {
  loginAction,
  logoutAction,
  initializePermissions,
  getpProjectListAction,
  selectProjectAction,
  setFavoriteProjectAction,
  sendOtpAction,
  verifyOtpAction,
  resetPasswordAction,
  registerUserAction,
  getUserPreferencesAction,
  updateUserPreferencesAction
}

